/**
 * COLOUR SWATCHES — 4 Sep 2026
 *
 * "More colours" opens the rest of the style downward, like an accordion, and
 * closes it again. It does two things it used to do badly:
 *
 *  - it no longer navigates to the collection page, which threw a shopper off
 *    the product she was looking at in order to show her more of it;
 *  - it no longer scrolls sideways. Colours hidden off the right edge need a
 *    gesture you have to guess at. Opening downward makes the page taller,
 *    which is a thing every shopper already knows how to deal with.
 *
 * Every swatch is already in the HTML, so opening and closing is instant.
 */
(function () {
  'use strict';

  function initAll() {
  document.querySelectorAll('[data-swatch-row]').forEach(function (row) {
    if (row.hasAttribute('data-sw-init')) return;
    row.setAttribute('data-sw-init', '1');

    var wrap = row.closest('.Swatches') || row.parentNode;
    var btn  = wrap.querySelector('[data-swatch-more]');
    if (!btn) return;

    var labelEl = btn.querySelector('[data-swatch-label]');
    var countEl = btn.querySelector('[data-swatch-left]');
    var moreLbl = btn.getAttribute('data-more-label') || 'More colours';
    var lessLbl = btn.getAttribute('data-less-label') || 'Fewer colours';

    // Remember what was hidden to begin with, so closing can put exactly those
    // back rather than guessing at a count.
    var extras = Array.prototype.slice.call(row.querySelectorAll('[data-swatch-hidden]'));
    if (!extras.length) { btn.hidden = true; return; }

    var open = false;

    function paint() {
      extras.forEach(function (el) { el.classList.toggle('is-hidden', !open); });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (labelEl) labelEl.textContent = open ? lessLbl : moreLbl;
      if (countEl) countEl.textContent = open ? '' : '(' + extras.length + ')';
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open = !open;
      paint();
      // Closing while scrolled past the row would leave the page jumping up
      // under the reader, so bring the row back into view only when it has
      // moved off the top.
      if (!open && row.getBoundingClientRect().top < 0) {
        row.scrollIntoView({ block: 'nearest' });
      }
    });

    paint();
  });
  }

  initAll();
  // The product section is replaced wholesale on a colour swap, and external
  // scripts are not re-run, so the new row would otherwise have no listeners.
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('page:loaded', initAll);
})();
